<div class="contact-body-container">
    <div class="no-data" [style.display]="noDataStyle">
        <span>No Data</span>
    </div>
    <div *ngFor="let item of config;trackBy:trackByFn">
        <div class="contact_body_item"
            *ngIf="item.value && item.value.length > 0 && item.subject !== 'Notes' &&item.subject !==synchTitle">
            <div class="title item-section">{{item.subject}}</div>
            <div *ngFor="let subItem of item.value;trackBy:trackByFn">
                <div *ngIf="subItem.title !== 'item-divider'">
                    <tam-contact-information-item [config]="subItem"></tam-contact-information-item>
                </div>
                <div *ngIf="subItem.title === 'item-divider'"><br /></div>
            </div>
            <hr class="item-divider" />
        </div>
        <div class="contact_body_item"
            *ngIf="item.value[0] && item.value[0].value[0] && item.value[0].value[0].value && item.subject === 'Notes'">
            <div class="title item-section">{{'crm.notes' | stringLiterals}}</div>
            <div tid="Notes" class="item-note body-1 item-note-value">{{item.value[0].value[0].value}}</div>
            <hr class="item-divider" />
        </div>

        <div *ngIf="item.subject ===synchTitle&&isShowSynch">
            <div class="contact-synch-title">
                <label class="title item-section">{{item.subject}}</label>
                <smart-icon *ngIf="statusIcon" [name]="statusIcon" class="synch-status-icon"></smart-icon>
            </div>
            <div class="contact-body-synch-status">
                <div *ngFor="let value of displaySynchStatusData;let i = index;trackBy:trackByFn">
                    <label class="synch-item" *ngIf="i!==clickIndex"
                        [ngClass]="{'synch-item-disabled':setStatusDisabled(value)}"
                        (click)=clickSynchStatus(value,i)>{{value}}
                        <span *ngIf="setStatusDisabled(value)&&isAdminUser" class="synch-item"
                            (click)=clickRemoveOwnerShip(value,i)>(Remove)</span>
                    </label>
                    <i class="tam-loading tam-loading-gray" *ngIf="i===clickIndex"></i>
                    <label class="synch-divider" *ngIf="i<displaySynchStatusData.length-1">|</label>
                </div>
            </div>
            <hr class="item-divider" />
        </div>
    </div>
</div>